import React from 'react';
import { Activity, Zap, ShieldCheck } from 'lucide-react';
import SEO from '../components/SEO';
import SpecialtyPageTemplate from '../components/SpecialtyPageTemplate';

const PhysiotherapyPage = () => {
  const config = {
    badge: "Rehab & Wellness",
    headline: "Physiotherapy &",
    headlineItalic: "Rehabilitation.",
    subtext: "Advanced physical rehabilitation protocols that restore mobility, reduce pain, and improve quality of life for post-surgical and arthritic patients.",
    image: "/images/services/diagnostics_lab.png",
    imageAlt: "Pet Physiotherapy at Dr. Suresh Pet Care — Rehabilitation Excellence",
    stats: [
      { value: 900, suffix: '+', label: 'Rehab Cases' },
      { value: 94, suffix: '%', label: 'Mobility Improvement' },
      { value: 6, suffix: '+', label: 'Years Expertise' },
      { value: 24, suffix: '/7', label: 'Emergency Access' },
    ],
    services: [
      {
        title: "Cold Laser Therapy",
        icon: <Zap size={28} />,
        desc: "Non-invasive photobiomodulation therapy to reduce inflammation, accelerate healing, and manage chronic pain.",
        specs: ["Pain Reduction", "Wound Healing", "Nerve Regeneration", "Anti-Inflammation"],
        color: "from-cyan-500/10 to-primary/10"
      },
      {
        title: "Manual Therapy",
        icon: <Activity size={28} />,
        desc: "Therapeutic massage, joint mobilization, and range-of-motion exercises to restore musculoskeletal function.",
        specs: ["Therapeutic Massage", "Joint Mobilization", "Passive ROM", "Post-Op Recovery"],
        color: "from-primary/10 to-blue-500/10"
      },
      {
        title: "Therapeutic Exercise",
        icon: <ShieldCheck size={28} />,
        desc: "Structured exercise programs including balance boards, cavalettis, and resistance training for muscle rebuilding.",
        specs: ["Balance Training", "Cavaletti Poles", "Strengthening", "Gait Analysis"],
        color: "from-green-500/10 to-primary/10"
      }
    ],
    sectionTitle: "Our Rehab",
    sectionItalic: "Services.",
    warningTitle: "Signs Your Pet Needs",
    warningItalic: "Physiotherapy.",
    warningText: "Physiotherapy can dramatically improve your pet's quality of life following surgery or during management of chronic musculoskeletal conditions.",
    warnings: [
      { name: "Post-Surgical Recovery", desc: "Rehabilitation accelerates healing and prevents muscle atrophy after surgery.", icon: "🔧" },
      { name: "Arthritis Pain", desc: "Chronic joint pain benefits significantly from laser therapy and mobility work.", icon: "🦴" },
      { name: "Neurological Conditions", desc: "IVDD and similar conditions require structured neurological rehabilitation.", icon: "⚡" },
      { name: "Sports Injuries", desc: "Working and sporting dogs benefit from structured musculoskeletal rehabilitation.", icon: "🏃" },
    ],
    ctaBadge: "Rehab Speciality",
    ctaTitle: "The Physiotherapy",
    ctaItalic: "Expertise.",
    ctaText: "Our rehabilitation specialists use evidence-based modalities to restore your pet's mobility and comfort, ensuring a swift return to a full quality of life.",
    ctaBtn: "Book Physio Session",
    seoText: "Expert pet physiotherapy and rehabilitation in Hyderabad. Cold laser therapy and post-surgical recovery for dogs at Dr. Suresh Pet Care.",
    glowColor: "cyan-500"
  };

  return (
    <>
      <SEO 
        title="Pet Physiotherapy & Rehabilitation"
        description="Advanced physical rehabilitation, cold laser therapy, and hydrotherapy for pets recovering from surgery or injury at Dr. Suresh Pet Care, Hyderabad."
        canonical="/physiotherapy"
      />
      <SpecialtyPageTemplate config={config} />
    </>
  );
};


export default PhysiotherapyPage;
